import React, { useEffect } from "react"
import { Switch, Route, Redirect, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import LoadingOverlay from 'react-loading-overlay';
import Homepage from "../components/Homepage";
import { TopicPosts, IntroPosts } from './Community'
import Termpage from "../components/Terms";
import PrivacyPolicyPage from "../components/PrivacyPolicy";
import WhosITForPage from "../components/WhosITForPage";
import PricingPage from "../components/PricingPage";
import ContactUsPage from "../components/ContactUsPage";
import ReferralPage from "../components/Referral";
import FeatureBrandPage from "../components/FeatureBrandPage";
import FollowPage from "../components/FollowContainer";
import EnrollAgencyPage from "../components/EnrollAgencyContainer";
import DeleteAccountPage from "../containers/DeleteAccountPageContainer";
import AuthForm from "../components/AuthForm"
import Help from "../components/Help"
import Stats from "../containers/Stats"
import Chat from "../containers/Chat"
import MembershipPlan from "../containers/MembershipPlan"
import PartnerAdd from "../components/PartnerAdd"
import { MediaLibrary } from "./Files"
import Upload from "../containers/Upload"
import { authUser, fetchUser, logout } from "../store/actions/auth"
import { removeError } from "../store/actions/errors"
import { getPaymentToken } from "../store/actions/payments"
import withAuth from "../hocs/withAuth"
import MessageForm from "../containers/MessageForm"
import Exercises, { MobileExercise, CreateExercise, CorporateExercises } from '../containers/Exercises'
import Instructions, { CreateInstruction } from '../containers/Instructions'
import Automations, { CreateAutomation } from '../containers/Automation'
import { CreateWorkout, CreateBlock, MyWorkouts, WorkoutInfo, PreviewWorkoutInfo } from './Workouts'
import { CreateProgram, ProgramLibrary, ProgramInfo, PreviewProgramInfo } from './Programs';
import { BlockInfo, MyBlocks } from './Blocks';
import NavContainer from '../components/nav/Container';
import { AssignClients, AssignMobileClients, AssignFeaturedBrand, AssignPartners, AssignMarketplace, MyAssignments, MyPartners } from './Assignments';
import { Donwloads } from './Donwloads';
import { Billing, BrandProfile, Preferences, Profile, PaypalConnection, PartnerSubscription } from '../components/settings';
import { AddBrand, BrandListing, EditBrand, EditTrainer, TrainerListing, EditNCEPTrainer, TrainerNCEPListing } from '../components/manageBrands';
import { AddPush } from '../components/managePushNotifications';
import SocialFeed from '../components/social/index';
import { MyStatements } from '../containers/MyStatements';
import { MyInvoices } from '../containers/MyInvoices';
import AlertMessage from '../components/AlertMessage';
import { PLANOPTION } from '../constants';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";


import { ManageCategories } from './Categories';
import ResetPassword from "../components/ResetPassword";
import DeleteAccountLink from "../components/DeleteAccountLink";

import ChangeEmailVerification from "../components/ChangeEmailVerification";
import ValidateMobileLogin from "../components/ValidateMobileLogin";
import AuthenticationError from "../components/authenticationError";

const isWebview = require("js-is-webview");
const is_webview = new isWebview();

const handlePageChange = () => {
  window.scrollTo(0, 0);
};

const Main = props => {
  const { authUser, errors, fetchUser, removeError, currentUser, logout, loader, location, getPaymentToken } = props;
  const { pathname } = location;
  let isCorportate = false;
  let isBrand = false;
  if (currentUser.isAuthenticated) {
    const user = currentUser.user;
    const userType = user.type;
    if (userType.includes('corporate')) {
      isCorportate = true;
    }
    if (userType.includes('brand')) {
      isBrand = true;
   }
  }
  useEffect(() => {
    fetchUser().then((response) => {
    }).catch(() => {
    });
  }, []);
  return (
    <LoadingOverlay
      active={loader.isShow}
      spinner={
        <Loader
          type="CradleLoader"
          visible={true}
        />
      }
      text="Loading"
    >
      <AlertMessage />
      {
        ( pathname === '/' ||
          pathname === '/terms' ||
          pathname === '/privacyPolicy' ||
          pathname === '/whosItFor' ||
          pathname === '/featureBrands' ||
          pathname === '/contactUs' ||
          pathname === '/pricing' ||
          pathname === '/successConnection' ||
          pathname === '/validateMobileLogin' ||
          pathname === '/authenticationError' ||
          pathname === '/mobileExcercise' ||
          pathname === '/mobileClients' ||
          pathname.includes('/resetPassword') ||
          pathname.includes('/delete-account') ||
          pathname.includes('/deleteAccountVerify') ||
          pathname.includes('/changeEmailVerification') ||
          pathname.includes('/follow') ||
          pathname.includes('/enroll-ncep-trainer') ||
          pathname.includes('/enroll-trainer-agency') || 
          pathname.includes('/brand')
        ) ?
        <Switch>
            <Route exact path="/" render={props => {
              handlePageChange();
                let userAgent = {
                    userAgent:navigator.userAgent
                }
                if (is_webview.check(userAgent)) {
                  return (<AuthenticationError
                    user={currentUser}
                    currentUser={currentUser}
                    {...props}
                  />)
                } else {
                  return (<Homepage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  getPaymentToken={getPaymentToken}
                  {...props}
                />)
                }
            }} />
            <Route exact path="/terms" render={props => {
              handlePageChange();
              return (
                <Termpage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />
            <Route exact path="/privacyPolicy" render={props => {
              handlePageChange();
              return (
                <PrivacyPolicyPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />
            <Route exact path="/brand/:referenceCode" render={props => {
              handlePageChange();
              return (
                <ReferralPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />

           <Route exact path="/featureBrands" onEnter={handlePageChange} render={props => {
              handlePageChange();
              return (
                <FeatureBrandPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />
          <Route exact path="/pricing" render={props => {
              handlePageChange();
              return (
                <PricingPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  getPaymentToken={getPaymentToken}
                  {...props}
                />
              )
            }} />
          <Route exact path="/contactUs" render={props => {
              handlePageChange();
              return (
                <ContactUsPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />
          <Route exact path="/whosItFor" render={props => {
              handlePageChange();
              return (
                <WhosITForPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  getPaymentToken={getPaymentToken}
                  {...props}
                />
              )
            }} />
            <Route path="/successConnection" render={props => {
              handlePageChange();
              return (
                <PaypalConnection
                  user={currentUser}
                  currentUser={currentUser}
                  {...props}
                />
              )
            }} />
            <Route exact path="/deleteAccountVerify/:verifyToken" render={props => {
              handlePageChange();
              return (
                  <DeleteAccountLink
                    user={currentUser}
                    logout={logout}
                    currentUser={currentUser}
                    removeError={removeError}
                    errors={errors}
                    onAuth={authUser}
                    {...props}
                  />
              )
            }} />
            <Route exact path="/resetPassword/:resetPasswordToken" render={props => {
              handlePageChange();
              return (
                <ResetPassword
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />
            <Route exact path="/changeEmailVerification/:changeEmailVerificationToken" render={props => {
              handlePageChange();
              return (
                <ChangeEmailVerification
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />
            <Route exact path="/follow/:referralCode" render={props => {
              handlePageChange();
              return (
                <FollowPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  getPaymentToken={getPaymentToken}
                  {...props}
                />
              )
            }} />
            <Route exact path="/enroll-ncep-trainer" render={props => {
              handlePageChange();
              return (
                <EnrollAgencyPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  isNCEP={true}
                  {...props}
                />
              )
            }} />
            <Route exact path="/enroll-trainer-agency" render={props => {
              handlePageChange();
              return (
                <EnrollAgencyPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  isNCEP={false}
                  {...props}
                />
              )
            }} />
             <Route exact path="/delete-account" render={props => {
              handlePageChange();
              return (
                <DeleteAccountPage
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  isNCEP={true}
                  {...props}
                />
              )
            }} />
            <Route path="/validateMobileLogin" render={props => {
              handlePageChange();
              return (
                <ValidateMobileLogin
                  user={currentUser}
                  currentUser={currentUser}
                  {...props}
                />
              )
            }} />
           
            <Route exact path="/mobileExcercise" render={props => {
              handlePageChange();
              return (
                <MobileExercise
                  user={currentUser}
                  logout={logout}
                  currentUser={currentUser}
                  onAuth={authUser}
                  {...props}
                />
              )
            }} />
        </Switch>
        :

      (<NavContainer currentUser={currentUser} logout={logout} {...props}>
        <div>
          <Switch>
            <Route exact path="/signin" render={props => {
              return (
                <AuthForm
                  logout={logout}
                  currentUser={currentUser}
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  buttonText="Log in"
                  heading="Welcome Back."
                  {...props}
                />
              )
            }} />
            <Route exact path="/signup" render={props => {
              return (
                <AuthForm
                  removeError={removeError}
                  errors={errors}
                  onAuth={authUser}
                  signUp
                  buttonText="Sign me up!"
                  heading="Join Warbler today."
                  {...props}
                />
              )
            }} />
            <Route path="/view-workout/:id" component={WorkoutInfo} />
            <Route path="/view-program/:id" component={ProgramInfo} />
            <Route path="/add-partner/:id" component={PartnerAdd} />
            <Route path="/add-partner/:id" component={PartnerAdd} />
          </Switch>
          {
            currentUser.isAuthenticated ? (
              <Switch>
                <Route exact path="/dashboard" render={() => <Redirect to="/build/workout" />} />
                { process.env.REACT_APP_ENV === 'prod' &&
                  <Route exact path="/chat" render={props => {
                    if(isBrand && currentUser) {
                      const user = currentUser.user;
                      if (user.planOption === PLANOPTION.TWO || user.planOption === PLANOPTION.FIVE) {
                        return <Chat {...props} ></Chat>
                      } else {
                        return <MembershipPlan {...props} ></MembershipPlan>
                      }
                    }
                    return <Chat {...props} ></Chat>
                  }} />
                }
                <Route exact path="/selectMembersipPlan" component={MembershipPlan} />
                <Route path="/users/:id/messages/new" component={withAuth(MessageForm)} />
                <Route path="/upload" component={withAuth(Upload)} />
                <Route path="/workouts/:id/edit" component={CreateWorkout} />
                <Route path="/workouts/:id" component={WorkoutInfo} />
                <Route path="/preview/workouts/:id" component={PreviewWorkoutInfo} />
                <Route path="/workouts" component={MyWorkouts} />
                <Route path="/library/workouts" component={MyWorkouts} />
                <Route path="/build/workout" component={CreateWorkout} />
                <Route path="/build/automationMessages" render={props => {
                  if(isBrand && currentUser) {
                    const user = currentUser.user;
                    if (user.planOption === PLANOPTION.TWO || user.planOption === PLANOPTION.FIVE) {
                      return <CreateAutomation {...props} ></CreateAutomation>
                    } else {
                      return <MembershipPlan {...props} ></MembershipPlan>
                    }
                  }
                  return <CreateAutomation {...props} ></CreateAutomation>
                }} />
                <Route path="/build/block" component={CreateBlock} />
                <Route path="/blocks/:id/edit" component={CreateBlock} />
                <Route path="/blocks/:id" component={BlockInfo} />
                <Route path="/blocks" component={MyBlocks} />
                <Route path="/library/blocks" component={MyBlocks} />
                <Route path="/build/program" component={CreateProgram} />
                <Route path="/programs/:id/edit" component={CreateProgram} />
                <Route path="/preview/programs/:id" component={PreviewProgramInfo} />
                <Route path="/programs/:id" component={ProgramInfo} />
                <Route path="/programs" component={ProgramLibrary} />
                <Route path="/library/programs" component={ProgramLibrary} />
                { (!isBrand && !isCorportate) && 
                   <Route path="/assign/clients" component={AssignClients} />
                }
                { (!isCorportate) && 
                  <Route path="/assign/mobile/clients" component={AssignMobileClients} />
                }
                { (isBrand) && 
                   <Route path="/assign/featured-brand" component={AssignFeaturedBrand} />
                }
                { (!isBrand && !isCorportate) && 
                   <Route path="/assign/partners" component={AssignPartners} />
                }
                {/* <Route path="/assign/marketplace" component={AssignMarketplace} /> */}
                <Route path="/share" component={MyPartners} />
                <Route path="/help" component={Help} />
                <Route path="/assignments/workout" render={props => {
                  if(isBrand && currentUser) {
                    const user = currentUser.user;
                    if (user.planOption === PLANOPTION.TWO 
                      || user.planOption === PLANOPTION.ONE
                      || user.planOption === PLANOPTION.FOUR
                      || user.planOption === PLANOPTION.FIVE
                      ) {
                      return <MyAssignments {...props} ></MyAssignments>
                    } else {
                      return <MembershipPlan {...props} ></MembershipPlan>
                    }
                  }
                  return <MyAssignments {...props} ></MyAssignments>
                }} />
                <Route path="/assignments/programs" render={props => {
                  if(isBrand && currentUser) {
                    const user = currentUser.user;
                    if (user.planOption === PLANOPTION.TWO 
                      || user.planOption === PLANOPTION.ONE
                      || user.planOption === PLANOPTION.FOUR
                      || user.planOption === PLANOPTION.FIVE
                      ) {
                      return <MyAssignments {...props} ></MyAssignments>
                    } else {
                      return <MembershipPlan {...props} ></MembershipPlan>
                    }
                  }
                  return <MyAssignments {...props} ></MyAssignments>
                }} />
                <Route path="/assignments/automations" render={props => {
                  if(isBrand && currentUser) {
                    const user = currentUser.user;
                    if (user.planOption === PLANOPTION.TWO 
                      || user.planOption === PLANOPTION.FIVE) {
                      return <MyAssignments {...props} ></MyAssignments>
                    } else {
                      return <MembershipPlan {...props} ></MembershipPlan>
                    }
                  }
                  return <MyAssignments {...props} ></MyAssignments>
                }} />

                <Route path="/download/workout" component={Donwloads} />
                <Route path="/download/programs" component={Donwloads} />

                <Route path="/manage-categories" component={ManageCategories} />
                <Route path="/exercises/:id/edit" component={CreateExercise} />
                <Route path="/library/exercises" component={Exercises} />
                <Route path="/library/media" component={MediaLibrary} />
                <Route path="/Fitbanx-exercises" component={CorporateExercises} />
                <Route path="/build/exercise" component={CreateExercise} />
                <Route path="/build/instruction" component={CreateInstruction} />
                <Route path="/library/instructions" component={Instructions} />
                <Route path="/library/automationMessages" render={props => {
                  if(isBrand && currentUser) {
                    const user = currentUser.user;
                    if (user.planOption === PLANOPTION.TWO || user.planOption === PLANOPTION.FIVE) {
                      return <Automations {...props} ></Automations>
                    } else {
                      return <MembershipPlan {...props} ></MembershipPlan>
                    }
                  }
                  return <Automations {...props} ></Automations>
                }}  />
                
                <Route path="/settings/preferences" render={props => {
                  return <Preferences currentUser={currentUser}></Preferences>
                }} />
                <Route path="/settings/invoices" render={props => {
                  return <MyInvoices currentUser={currentUser}></MyInvoices>
                }} />
                <Route path="/settings/billing" render={props => {
                  return <Billing {...props} removeError={removeError} currentUser={currentUser} logout={logout}></Billing>
                }} />
                <Route path="/successConnection" component={PaypalConnection} />
                <Route path="/settings/statements" render={props => {
                  return <MyStatements currentUser={currentUser}></MyStatements>
                }} />
                <Route path="/settings/edit-profile" render={props => {
                  return currentUser && currentUser.user && currentUser.user.type.includes('trainer') ?
                    <Profile currentUser={currentUser}></Profile>
                    : currentUser && currentUser.user && currentUser.user.type.includes('corporate') ? <Preferences currentUser={currentUser}></Preferences> : <BrandProfile currentUser={currentUser}></BrandProfile>
                }} />
                 { isCorportate && 
                  <React.Fragment>
                    <Route path="/manageBrands/add" render={props => {
                        return <AddBrand  removeError={removeError}  {...props}></AddBrand>
                    }} />
                    <Route exact path="/stats" render={props => {
                        return <Stats  removeError={removeError}  {...props}></Stats>
                    }} />
                   
                    
                <Route path="/managePushNotifications/add" render={props => {
                  return <AddPush  removeError={removeError}  {...props}></AddPush>
                }} />
                
                <Route path="/manageBrands/listing" render={props => {
                    return <BrandListing   removeError={removeError}  {...props}></BrandListing>;
                }} />
                <Route path="/manageBrands/edit" render={props => {
                  return <EditBrand  removeError={removeError}  {...props}></EditBrand>;
                }} />
                <Route path="/manageNCEPTrainers/edit" render={props => {
                  return <EditNCEPTrainer  removeError={removeError}  {...props}></EditNCEPTrainer>;
                }} />
                <Route path="/manageNCEPTrainers/listing" render={props => {
                    return <TrainerNCEPListing   removeError={removeError}  {...props}></TrainerNCEPListing>;
                }} />
                <Route path="/manageTrainers/edit" render={props => {
                  return <EditTrainer  removeError={removeError}  {...props}></EditTrainer>;
                }} />
                <Route path="/manageTrainers/listing" render={props => {
                    return <TrainerListing   removeError={removeError}  {...props}></TrainerListing>;
                }} />
                    
                </React.Fragment>
                }
                { 
                  isBrand && 
                  <React.Fragment>
                    <Route path="/social/posts" exact render={props => {
                      return <TopicPosts removeError={removeError}  {...props}></TopicPosts>
                    }} />
                    <Route path="/social/mobile/posts" exact render={props => {
                      return <TopicPosts isMobile={true}  removeError={removeError}  {...props}></TopicPosts>
                    }} />
                  </React.Fragment>
                }
              </Switch>
                ) : <Redirect to={'/'} />
          }

        </div>
      </NavContainer>)
    }
    </LoadingOverlay>
  )
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
    errors: state.errors,
    loader: state.loader
  }
}

export default withRouter(connect(mapStateToProps, { authUser, fetchUser, removeError, logout, getPaymentToken })(Main))



// WEBPACK FOOTER //
// ./src/containers/Main.js